// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalHeaderUsername-root-362d6c4a05c941988161e5f2a15eb952"};